"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      listLoading: false,
      currPage: 1,
      list: [],
      limit: 10,
      total: 0
    };
  },
  mounted: function mounted() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          'any object': {}
        }
      };
      this.listLoading = true;
      this.$api.district.getpProvincesList(param).then(function (res) {
        _this.listLoading = false;
        _this.list = res.data.items;
        _this.total = res.data.totalCount;
      }).catch(function (err) {
        console.log('-------', err);
        _this.listLoading = false;
      });
    }
  }
};